import $ from 'jquery';
import formatArticles from './formatArticles';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatArticles(`[data-section-id="${e.detail.sectionId}"]`);
  });
};